export enum PaymentScreenType {
  Appointment = 1,
  CashRefund = 2
}
